import { openSupportChat } from './crisp'

/**
 * The student and teacher discount, as both plan pages answer it (/setting#plan and the
 * onboarding plan page). There is no self-serve flow: the learner messages support in Crisp with
 * their school and a photo of their proof, and the team applies the discount by hand. Crisp's
 * chatbox has file transfer on, so the photo can be attached in the same message.
 *
 * The question, answer and button are translation keys in the `offers` namespace: t(key).
 */
export const STUDENT_DISCOUNT_FAQ_KEYS = {
  q: 'offers:studentDiscount.question',
  a: 'offers:studentDiscount.answer',
  action: 'offers:studentDiscount.action',
} as const

/**
 * English only, for PlanFaq (/setting#plan) until it moves to STUDENT_DISCOUNT_FAQ_KEYS. Keep it in
 * step with `studentDiscount` in locales/en/offers.json.
 */
export const STUDENT_DISCOUNT_FAQ = {
  q: 'Do you offer student or teacher discounts?',
  a: 'Yes, on some of our plans. Message us with the name of your school or university and a photo of your student or staff card, or a letter from your school. Make sure we can see when it expires or when your studies end.',
  action: 'Request a discount',
}

/**
 * Opens Crisp with the request half-written and tagged, so they only add the school and the photo.
 * The message stays in English: the learner sends it to the support team, who work in English and
 * Chinese.
 */
export const requestStudentDiscount = (email?: string) =>
  openSupportChat({
    email,
    message: "Hi! I'd like the student or teacher discount. My school or university is: ",
    segment: 'student-teacher-discount',
  })
